import { getAccessToken } from "./accessToken";
import { buildAuthHeaders } from "./authHeaders";

/**
 * Axios header object with OIDC access token (Bearer + legacy pxtoken/PXToken).
 */
export async function getAxiosAuthHeaders(extra = {}) {
  const token = await getAccessToken();
  return { ...buildAuthHeaders(token), ...extra };
}
